/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.98"
        height="94.4"
        viewBox="0 0 82.98 94.4"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M41.46 11.42A41.49 41.49 0 1 0 82.98 52.9a41.5 41.5 0 0 0-41.52-41.48Zm0 2.5a39 39 0 1 1-39 39 39 39 0 0 1 39-39Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M35.32 12.67h13.23V4.3H35.32v8.37z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M52.39 6.81h-20.9a.5.5 0 0 1-.5-.5V.5a.52.52 0 0 1 .5-.5h20.9a.52.52 0 0 1 .5.5v5.81a.5.5 0 0 1-.5.5"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M39.82 30.56v3.88l-.6.11-.61.12a9.3 9.3 0 0 0-7 5.68 11.7 11.7 0 0 0-.81 5.3 9.12 9.12 0 0 0 4.87 7.74 40.06 40.06 0 0 0 4.07 1.82c1.7.72 3.43 1.37 5.13 2.09a3.11 3.11 0 0 1 1.94 3.39 3.39 3.39 0 0 1-2.72 3.39 9.77 9.77 0 0 1-2.15.24 5.35 5.35 0 0 1-5.47-4c-.15-.48-.27-1-.42-1.49l-6.49 1.67a13.54 13.54 0 0 0 3.14 6.43 11 11 0 0 0 7.12 3.29v5h4.16v-5c.85-.17 1.67-.3 2.47-.5a9.7 9.7 0 0 0 6.83-5.55 11.28 11.28 0 0 0 .79-6.78 8.94 8.94 0 0 0-4.5-6.39 52 52 0 0 0-6.22-2.72c-1.27-.51-2.51-1.09-3.75-1.7a2.73 2.73 0 0 1-1.39-1.69 3.8 3.8 0 0 1 2.52-4.74h.13a4.43 4.43 0 0 1 4.35 1.14 8.14 8.14 0 0 1 1.77 2.63c.15.32.28.64.43 1l5.81-2.4a11.61 11.61 0 0 0-2.13-4.38 10.3 10.3 0 0 0-7.11-3.7v-3.88Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M74.7 22.32 64.25 14a.5.5 0 0 1-.08-.7l2.75-3.47a.51.51 0 0 1 .71-.08L78.07 18a.5.5 0 0 1 .08.7l-2.75 3.5a.49.49 0 0 1-.69.09"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="m68.57 23.74-4.28-3.4 4.74-5.97 4.28 3.39-4.74 5.98z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'StopwatchWithDollarSignIcon';

export default Icon;
